if (!customElements.get('image-with-text')) {
  class ImageWithText extends HTMLElement {
    constructor() {
      super();

      this.imageButtons = this.querySelectorAll('.image-with-text__image-button');
      this.imageCard = {
        container: this.querySelector('.image-with-text__image-card'),
        title: this.querySelector('.image-with-text__image-card-title'),
        text: this.querySelector('.image-with-text__image-card-text'),
      };
      this.imageButtonsTemplate = this.querySelector('.image-with-text__image-container template').content;
    }

    connectedCallback() {
      this.listenEvents();
    }

    listenEvents() {
      this.imageButtons.forEach((imageButton) => {
        imageButton.addEventListener('click', this.toggleActive.bind(this));
      });

      this.imageButtons.forEach((imageButton) => {
        imageButton.addEventListener('mouseenter', this.toggleActive.bind(this));
      });
    }

    toggleActive(event) {
      event.preventDefault();

      const value = parseInt(event.target.getAttribute('data-value'));
      const imageCardText = this.imageButtonsTemplate.querySelector(`[data-value="${value}"][data-text]`).innerHTML;
      const imageCardTitle = this.imageButtonsTemplate.querySelector(`[data-value="${value}"][data-title]`).innerHTML;

      if (imageCardText) this.imageCard.text.innerHTML = imageCardText;
      if (imageCardTitle) this.imageCard.title.innerHTML = imageCardTitle;
    }
  }
  customElements.define('image-with-text', ImageWithText);
}
